<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :span="12">
            <a-form-item
              :label="$t(I18N_KEY.REPAYREPORT + 'requestDate')"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 14, offset: 1 }"
            >
              <a-range-picker v-model="queryParam.examineDate" format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'产品类型'">
              <a-select v-model="queryParam.appssid" @change="onChange">
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!--<a-col :span="12">-->
          <!--<a-form-item :label="'期限'">-->
          <!--<a-select default-value="" style="width: 120px" v-model="queryParam.duration">-->
          <!--<a-select-option value="">-->
          <!--全部-->
          <!--</a-select-option>-->
          <!--<a-select-option value="7">-->
          <!--7天-->
          <!--</a-select-option>-->
          <!--<a-select-option value="14">-->
          <!--14天-->
          <!--</a-select-option>-->
          <!--</a-select>-->
          <!--</a-form-item>-->
          <!--</a-col>-->

        </a-row>
        <a-row :gutter="12">
          <a-col :md='6' :sm='8'>
            <a-form-item label="前收后收">
              <a-select default-value="" style="width: 120px" v-model="queryParam.receiptTimeFlag">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  前收
                </a-select-option>
                <a-select-option value="1">
                  后收
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='6'>
            <a-form-item label="运营类型">
              <a-select default-value="" style="width: 120px" v-model="queryParam.proxyFlag">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  自运营
                </a-select-option>
                <a-select-option value="1">
                  代理运营
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery('')" icon="search" style="margin-left: 8px">{{
                  $t('search')
                }}</a-button>
              <a-button type="primary" @click="searchQuery('1')" icon="search" style="margin-left: 8px">首贷</a-button>
              <a-button type="primary" @click="searchQuery('2')" icon="search" style="margin-left: 8px">复贷</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                  $t('reset')
                }}</a-button>
              <!--<a-button type="primary" @click="downLoadData" icon="download" style="margin-left: 8px">{{ $t('exportFile') }}</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered
        @change="handleTableChange"
      >
        <Dict slot="approvalStatus" slot-scope="text" :dict-code="DICT_CODE.ORDER_STATUS">{{ text }}</Dict>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplist, getRepaymentReportForAmount } from '@/webpublicapi/order'
import exportFile from '@/webpublicapi/exportFile'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.',
  REPAYREPORT: 'repayReport.'
}
export default {
  name: 'repayReport',
  components: {
    Dict,
    DictSelect
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      exportParams: '',
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      appList: [],
      // 查询条件
      queryParam: {
        receiptTimeFlag:'',
        examinerName: '',
        appssid: '',
        duration: '',
        examineDate: undefined
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'curDate'),
          align: 'left',
          dataIndex: 'curDate'
        },
        {
          title: '放款笔数',
          align: 'left',
          dataIndex: 'countLoanSuccess'
        },
        {
          title: '到期应还款',
          align: 'left',
          dataIndex: 'curAmount'
        },
        {
          title: '实际还款金额（含部分还款）',
          align: 'left',
          dataIndex: 'profitAmount'
        },
        {
          title: '放款金额',
          align: 'left',
          dataIndex: 'paymentAmt'
        },
        {
          title: '利润',
          align: 'left',
          dataIndex: 'profit'
        },
        {
          title: '首逾',
          align: 'left',
          dataIndex: 'firstOverDueRate'
        },
        {
          title: '实时逾期率（含滞纳金）',
          align: 'left',
          dataIndex: 'overDueRate'
        },
        {
          title: '实时逾期率（不含滞纳金）',
          align: 'left',
          dataIndex: 'overDueNoLateFeeRate'
        },
        {
          title: '实时逾期率（含部分还款）',
          align: 'left',
          dataIndex: 'overDuePartRate'
        },
        {
          title: '利润率',
          align: 'left',
          dataIndex: 'profitRate'
        }
      ]
    }
  },
  created() {
    this.loadData(1)
    getApplist().then(res => {
      this.appList = []
      this.appInList = res.data || []
      for (var i = 0; i < this.appInList.length; i++) {
        if (this.appInList[i].appssid != '') {
          this.appList.push(this.appInList[i])
        }
      }
    })
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery(arg) {
      this.loadData(1, arg)
    },
    loadData(arg, arg2) {
      // 加载数据 若传入参数1则加载第一页的内容
      console.log(arg2)
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams(arg2) // 查询条件
      this.exportParams = Object.entries(params).map(([key, value]) => key + '=' + value)
      getRepaymentReportForAmount(Object.assign({}, params))
        .then(res => {
          if (res.code === 1000) {
            // this.total = res.data && res.data.total
            this.dataSource = res.data || []

            for (var i = 0; i < this.dataSource.length; i++) {
              var dataIn = this.dataSource[i]
              dataIn.profit = (dataIn.profitAmount - dataIn.paymentAmt).toFixed(2)
              // 格式化
              dataIn.curAmount = this.formatNumber(dataIn.curAmount)
              dataIn.profitAmount = this.formatNumber(dataIn.profitAmount)
              dataIn.paymentAmt = this.formatNumber(dataIn.paymentAmt)
              dataIn.profit = this.formatNumber(dataIn.profit)
            }
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    downLoadData() {
      const file = {
        fileUrl: '/api/web/statistics/platform/repaymentReportExcel?' + this.exportParams,
        fileName: 'report.xls'
      }
      this.loading = true
      exportFile(file)
        .catch(e => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams(arg) {
      const { examineDate } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: examineDate && this.transformTime(examineDate[0]),
        endDate: examineDate && this.transformTime(examineDate[1]),
        loanType: arg
      }
      delete data.examineDate
      return filterObj(data)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.examinerName = ''
      that.queryParam.examineDate = undefined
      that.queryParam.receiptTimeFlag = ''
      that.loadData(this.form.pageNum)
    },
    formatNumber(value) {
      if (value === undefined || value === null || value === '') return '';
      // 先转为整数，再加千分位
      return Number(value).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
